// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"f1efc573f35495400fe0","655":"46b1f553dfabcc415054"}[chunkId] + ".js";
};